import { createReducer, on } from "@ngrx/store";
import { loadCurvesActions } from "../load_curves.actions";
import { Customer } from "../../../models/customer.model";

export interface CustomerState {
    customers: Customer[]|null,
    state: 'pending'|'loading'|'loaded'|'error'
}

export const initialState: CustomerState = {
    customers: null,
    state: 'pending'
};

export const loadCurvesCustomersReducer = createReducer(
    initialState,
    on(loadCurvesActions.getCustomers, (state) => ({
        ...state,
        customers: null,
        state: 'loading' as const
    })),
    on(loadCurvesActions.getCustomersSuccess, (state, {payload}) => ({
        ...state,
        customers: payload,
        state: 'loaded' as const
    })),
    on(loadCurvesActions.getCustomersFail, (state) => ({
        ...state,
        customers: null,
        state: 'error' as const
    }))
)